{
  "validation.maxAttachments": "{{max}}개의 파일만 첨부할 수 있어요.",
  "validation.minAttachments": "{{min}}개 이상의 첨부 파일이 필요해요.",
  "validation.maxAttachmentSize": "첨부 파일은 {{max}}MB를 초과할 수 없어요.",
  "validation.attachmentListItemRequired": "{{category}}\"에 대한 첨부 파일을 제공하세요.",
  "validation.attachmentListItemMaxAttachments": "{{category}}\"에 대한 {{max}}개의 첨부 파일만 허용됩니다.",
  "validation.attachmentListItemMaxAttachmentSize": "{{category}} 첨부 파일은 {{max}} 메가바이트보다 클 수 없습니다.",
  "attachment.bsoCategory.DiagnosticReport": "진단 리포트",
  "attachment.bsoCategory.InvoiceDocument": "청구서",
  "attachment.bsoCategory.ShippingDocument": "배송 서류",
  "attachment.bsoCategory.Letter": "편지",
  "attachment.bsoCategory.PictureReference": "사진 참고",
  "attachment.bsoCategory.BugReport": "버그 리포트",
  "attachment.bsoCategory.Other": "기타",
  "attachment.bsoCategory.Unclassified": "분류되지 않음",
  "attachment.bsoCategory.ServiceForms": "서비스 신청서",
  "attachment.bsoCategory.RegistrationDocument": "등록 서류",
  "attachment.bsoCategory.ShopInside": "매장 내부 사진",
  "attachment.bsoCategory.ShopImageMigration": "매장 이미지 이전",
  "attachment.bsoCategory.ShopImage": "매장 외관 사진",
  "attachment.uploadButton": "{{category}} 업로드",
  "attachment.uploadDropdown": "파일 업로드"
}